import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import { Loader, ShowToastError, ShowToastSuccess, ShowToastWarning } from "@platformx/utilities";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import graphQluserRole from "../../api/fetch";
import { createAndUpdateRole } from "../../helper/helper";

const TopHeader = ({
  checkedPermissions,
  setLoading,
  newRole,
  setNewRole,
  setaddNewRoleButtonEnable,
  addNewRoleButtonEnable,
  setTriggerUpdate,
  prevpermissionRef,
}) => {
  const theme = useTheme();
  const [xspinner, setXspinner] = useState(false);
  const navigate = useNavigate();
  const hasPermissionsChanged = (prevPermissions, newPermissions) => {
    return JSON.stringify(prevPermissions) !== JSON.stringify(newPermissions);
  };
  const { createRole, updateRole } = createAndUpdateRole(checkedPermissions);
  const isChanged = hasPermissionsChanged(prevpermissionRef.current, updateRole); // true if changed, false otherwise
  const createAndUpdate = () => {
    if (!newRole && addNewRoleButtonEnable === false) {
      ShowToastError("Please enter valid role name");
    } else if (newRole && createRole?.length === 0) {
      ShowToastError("Select the permissions to create role");
    } else if (createRole?.length > 0) {
      createUserRole();
    }
    if (updateRole && updateRole?.length > 0 && isChanged) {
      updateUserRole(updateRole);
    }
    // else if (!isChanged && !newRole && updateRole?.length > 0) {
    //   ShowToastError("No changes detected in permissions");
    // }
  };
  const createUserRole = async () => {
    try {
      setXspinner(true);
      setLoading(true);
      const res = await graphQluserRole.createRole({
        input: {
          permissions: createRole?.[0]?.permissions,
          name: newRole,
          description: "",
        },
      });
      if (res?.data?.authoring_createRole?.message) {
        ShowToastSuccess(res?.data?.authoring_createRole?.message);
        setaddNewRoleButtonEnable(true); // plus button will show again
        setNewRole(""); //clear the input field
        setTriggerUpdate((prev) => !prev); //rerender the component to get new data
      } else if (res?.errors?.[0]) {
        ShowToastError(res?.errors?.[0].message || "Failed to create role");
        setaddNewRoleButtonEnable(true);
      }
    } catch (error) {
      const errorMessage =
        (error instanceof Error && error.message) ||
        (typeof error === "string" ? error : "Failed to create role");
      ShowToastWarning(errorMessage);
      setaddNewRoleButtonEnable(false);
      setTriggerUpdate((prev) => !prev);
    } finally {
      setLoading(false);
      setXspinner(false);
    }
  };
  const updateUserRole = async (tobeUpdate) => {
    try {
      setXspinner(true);
      setLoading(true);
      const res = await graphQluserRole.updateRole({
        input: {
          roles: [...tobeUpdate],
          description: "",
        },
      });
      if (res?.data?.authoring_updateRole?.message) {
        ShowToastSuccess(res?.data?.authoring_updateRole?.message);
        setaddNewRoleButtonEnable(true);
        setNewRole(""); //clear the input field
        setTriggerUpdate((prev) => !prev); //rerender component
      } else {
        ShowToastError("Failed to Update role");
        setaddNewRoleButtonEnable(true);
      }
    } catch (error) {
      ShowToastError("Failed to Update role");
      setaddNewRoleButtonEnable(true);
    } finally {
      setLoading(false);
      setXspinner(false);
    }
  };
  const navigateToUserRole = () => {
    navigate("/user-management/user-roles");
  };
  return (
    <Box className='permissiontophead'>
      <Box className='d-flex align-items-center'>
        <IconButton
          onClick={navigateToUserRole}
          aria-label='west'
          size='medium'
          disableRipple
          disableFocusRipple>
          <KeyboardBackspaceRoundedIcon sx={{ color: theme.palette.customColor.PRIMARY }} />
        </IconButton>
        <Typography variant='h3semibold'>User Role Management</Typography>
      </Box>
      <Button
        data-testid='addnew'
        variant='primaryButton'
        disabled={!isChanged && !newRole}
        onClick={createAndUpdate}>
        publish
      </Button>
      {xspinner && <Loader />}
    </Box>
  );
};

export default TopHeader;
